import { on } from 'delegated-events'

const navigationMenu = document.querySelector('.section-navigation-menu')

const fn = {
  init: () => {
    on('click', '.section-navigation-trigger', fn.handleMenu)

    window.addEventListener('click', fn.handleOutsideClick)
  },

  handleMenu: (e) => {
    if (navigationMenu) {
      e.stopPropagation()

      navigationMenu.classList.toggle('is-active')
      document.documentElement.classList.toggle('overflow-hidden')
    }
  },

  handleOutsideClick: (e) => {
    if (navigationMenu && navigationMenu.classList.contains('is-active')) {
      if (!e.target.closest('.section-navigation-menu')) {
        navigationMenu.classList.remove('is-active')
        document.documentElement.classList.remove('overflow-hidden')
      }
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
